import { render } from "./TagCounterIndicator.vue?vue&type=template&id=496d2b4c&scoped=true&ts=true"
import script from "./TagCounterIndicator.vue?vue&type=script&lang=ts"
export * from "./TagCounterIndicator.vue?vue&type=script&lang=ts"

import "./TagCounterIndicator.vue?vue&type=style&index=0&id=496d2b4c&lang=scss&scoped=true"

import exportComponent from "/tmpfs/builds/maltcommunity/malt/apps/malt/node_modules/.pnpm/vue-loader@17.0.1_p6ywf2fz4v3oextcdrklqlunue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-496d2b4c"]])

export default __exports__